import 'url-search-params-polyfill';
import fetch from 'cross-fetch';

/*
API Service for receiving and sending out data
Docs under:
https://www.notion.so/demodern/Dev-Documentation-bbfba37deb34479eb91c690a4f70331e
*/

export const fetcher = (url, params, options = {}, lang) => {
  if (params) {
    url += `&${new URLSearchParams(params).toString()}`;
  } else {
    url += '?lang=' + lang;
  }

  return fetch(url, options)
    .then(res => {
      if (!res.ok || res.status >= 400) throw new Error(`${res.status} = ${res.statusText}`);

      const contentType = res.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        return res.json();
      }
      return res.blob();
    })
    .catch(err => {
      // we log the error but pass on the error
      // eslint-disable-next-line no-console
      console.error(`Could not fetch ${url}`, err);
      throw new Error(err, url);
    });
};

export const fetchUserData = lang =>
  fetcher(process.env.VUE_APP_API_URL + process.env.VUE_APP_GET_USER_DATA, false, false, lang);
export const fetchQuestionSections = lang =>
  fetcher(
    process.env.VUE_APP_API_URL + process.env.VUE_APP_GET_QUESTION_SECTIONS,
    false,
    false,
    lang
  );
export const apiSendUserDataToDB = params =>
  // fetcher(process.env.VUE_APP_API_URL + process.env.VUE_APP_SEND_USER_DATA, params, {
  fetcher("https://sap-intelligent-enterprise.k8s.dmdr.io/actions/sapapi/default/add-new-web-user", params, {
    method: 'post',
  });
